export default {
    countCard: [
        { MS: { r: [5, 8], tx: [0, -50], o: [1, 0] } },
        { MS: { r: [5, 8], tx: [0, -50], o: [1, 0] } },
        { MS: { r: [5, 8], tx: [0, -50], o: [1, 0] } },
    ],
};
